export const getContentInstanceSlugFromUrl = (urlStr?: string | null): string | undefined => {
    if (!urlStr) {
        return undefined;
    }

    try {
        const parsedUrl = new URL(urlStr);
        const segments = parsedUrl.pathname.split('/').filter((segment) => segment.length > 0);

        return segments.length > 0 ? segments[0] : undefined;
    } catch (error) {
        return undefined;
    }
};
